import React from 'react';

const IMic = ({ fill, width, height }) => {
  return (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14">
            <g id="Group_1710998" data-name="Group 1710998" transform="translate(-7251 -12684)">
                <rect id="Rectangle_448427" data-name="Rectangle 448427" width="14" height="14" transform="translate(7251 12684)" fill="none"/>
                <g id="microphone" transform="translate(7174.664 12682.233)">
                <g id="Group_1710842" data-name="Group 1710842" transform="translate(78.336 7.851)">
                    <g id="Group_1710841" data-name="Group 1710841" transform="translate(0)">
                    <path id="Path_1823405" data-name="Path 1823405" d="M88.336,209.947a.552.552,0,0,0-1.1,0,3.9,3.9,0,0,1-7.794,0,.552.552,0,0,0-1.1,0,4.925,4.925,0,0,0,4.449,4.864v1.436h-2a.539.539,0,1,0,0,1.077h5.11a.539.539,0,1,0,0-1.077h-2v-1.436A4.925,4.925,0,0,0,88.336,209.947Z" transform="translate(-78.336 -209.408)" fill={fill} />
                    </g>
                </g>
                <g id="Group_1710844" data-name="Group 1710844" transform="translate(80.338 1.767)">
                    <g id="Group_1710843" data-name="Group 1710843" transform="translate(0)">
                    <path id="Path_1823406" data-name="Path 1823406" d="M135.094,0a2.848,2.848,0,0,0-3,2.658V6.973a3.018,3.018,0,0,0,6,.016V2.658A2.848,2.848,0,0,0,135.094,0Z" transform="translate(-132.096)" fill={fill} />
                    </g>
                </g>
                </g>
            </g>
        </svg>
    </>
  )
};

export default IMic;
